import {JsonProperty} from 'json-typescript-mapper/index';

export class EnergyConsumption {
  @JsonProperty('id')
  id?: number;
  @JsonProperty('evasiveDate')
  evasiveDate?: string;
  @JsonProperty('marketdayNumber')
  marketdayNumber?: string;
  @JsonProperty('keyword')
  keyword?: string;
  @JsonProperty('dayString')
  dayString?: string;
  @JsonProperty('classification')
  classification?: string;
  @JsonProperty('branchNumber')
  branchNumber?: string;
  @JsonProperty('energyTotal')
  energyTotal?: number;
  @JsonProperty('boothsWithEnergy')
  boothsWithEnergy?: number;
  @JsonProperty('boothsWithLowEnergy')
  boothsWithLowEnergy?: number;
  @JsonProperty('boothsWithNormalEnergy')
  boothsWithNormalEnergy?: number;
  @JsonProperty('boothsWithSpecialEnergy')
  boothsWithSpecialEnergy?: number;
  @JsonProperty('area')
  area?: number;
  @JsonProperty('energyAvgVe')
  energyAvgVe?: number;
  @JsonProperty('energyAvgVePlausible')
  energyAvgVePlausible?: string;
  @JsonProperty('energyAvgSqm')
  energyAvgSqm?: number;
  @JsonProperty('energyAvgSqmPlausible')
  energyAvgSqmPlausible?: string;
  @JsonProperty('openingDuration')
  openingDuration?: number;
  @JsonProperty('weightedEnergyUnits')
  weightedEnergyUnits?: number;
  @JsonProperty('weightedEnergyAvgVe')
  weightedEnergyAvgVe?: number;

  constructor() {
    this.id = void 0;
    this.evasiveDate = void 0;
    this.marketdayNumber = void 0;
    this.keyword = void 0;
    this.dayString = void 0;
    this.classification = void 0;
    this.branchNumber = void 0;
    this.energyTotal = void 0;
    this.boothsWithEnergy = void 0;
    this.area = void 0;
    this.energyAvgVe = void 0;
    this.energyAvgVePlausible = void 0;
    this.energyAvgSqm = void 0;
    this.energyAvgSqmPlausible = void 0;
    this.openingDuration = void 0;
    this.boothsWithSpecialEnergy = void 0;
    this.boothsWithNormalEnergy = void 0;
    this.boothsWithLowEnergy = void 0;
    this.weightedEnergyUnits = void 0;
    this.weightedEnergyAvgVe = void 0;
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/energy-consumption.model.ts